module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Nostalgie.935db18a-ps.jpg";